<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col :cols="mobile() ? '12' : '11'" class="mx-auto pb-0">
        <v-btn
          color="darktext"
          class="rounded-xxl text-none white--text px-4"
          @click="goBack"
        >
          <v-icon>mdi-chevron-left</v-icon>{{ $t("backToSurveys") }}
        </v-btn>
        <span class="float-right">
          <v-menu v-if="mobile()" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list class="menulist-drawer" data-testid="menu-list">
              <v-list-item
                :class="{
                  'v-list-item--active accent--text': $route.name === 'SurveyOverview'
                }"
                @click="showSurveyOverview"
              >
                <v-list-item-title>{{ $t("summary") }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{
                  'v-list-item--active accent--text':
                    $route.name === 'SurveyIndividuals' ||
                    $route.name === 'SurveyOverviewUser',
                }"
                @click="showSurveyIndividuals"
              >
                <v-list-item-title>{{ $t("individuals") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p class="pt-5 text-h5 font-weight-bold"
        :align="mobile() ? 'center' : 'left'"
        >
          {{ $t("summarySurveyTitle") }}
        </p>
      </v-col>
      <v-col v-if="!mobile()" cols="11" class="mx-auto custom-tab-menu py-0">
        <v-list class="py-0" flat>
          <v-list-item
            :class="{ 'v-list-item--active accent--text': $route.name === 'SurveyOverview' }"
            @click="showSurveyOverview"
          >
            {{ $t("summary") }}
          </v-list-item>
          <v-list-item
            :class="{
              'v-list-item--active accent--text':
                $route.name === 'SurveyIndividuals' ||
                $route.name === 'SurveyOverviewUser',
            }"
            @click="showSurveyIndividuals"
          >
            {{ $t("individuals") }}
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <router-view></router-view>
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import AlertMessages from "../../components/AlertMessages";

export default {
  components: {
    AlertMessages,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: "",
      alertType: "",
      alertValue: false,
      activityId: this.$route.params.id,
      surveyId: this.$route.params.surveyId
    };
  },
  methods: {
    showSurveyOverview() {
      if (this.$route.name != "SurveyOverview") {
        this.$router.push({
          path:
            "/activity/" +
            this.activityId +
            "/survey/" +
            this.surveyId +
            "/summary",
        });
      }
    },
    showSurveyIndividuals() {
      if (this.$route.name != "SurveyIndividuals") {
        this.$router.push({
          path:
            "/activity/" +
            this.activityId +
            "/survey/" +
            this.surveyId +
            "/individuals",
        });
      }
    },
    goBack() {
      // this.$router.push({path: this.$router.back()}).catch(()=>{});
      this.$router.push({ path: "/activity/" + this.activityId + "/surveys" });
    },
  },
};
</script>
